import { useMemo } from 'react';
import { Stack, Typography } from '@mui/joy';
import { useParams } from 'react-router-dom';
import { useGetTagsQuery } from '@/features/tags/api';
import { EmojiDisplay } from '@/components/EmojiDisplay';

export function RecipeCardStats({ recipe }) {
  const { householdId } = useParams();
  const { data } = useGetTagsQuery({ householdId }, { skip: !householdId });

  const tagEmojis = useMemo(() => {
    const emojiByName = Object.fromEntries((data?.data || []).map(t => [t.name, t.emoji]));
    return [...new Set((recipe.tags || []).map(name => emojiByName[name]).filter(Boolean))];
  }, [data, recipe.tags]);

  const hasNutrition = !!recipe.nutrition && recipe.servings > 0;
  const kcalPerServing = hasNutrition ? Math.round(recipe.nutrition.kcal / recipe.servings) : null;

  if (tagEmojis.length === 0 && !hasNutrition) {
    return null;
  }

  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="space-between" sx={{ flexWrap: 'wrap' }}>
      {hasNutrition && <Typography level="title-xs">{kcalPerServing} kcal</Typography>}
      <Stack gap={0.5} direction="row" alignItems="center">{tagEmojis.map((emoji, index) => <EmojiDisplay key={index} emoji={emoji} size={14} />)}</Stack>
    </Stack>
  );
}
